<template>
  <div>
    <h3 class="title is-3">Summary Report</h3>
    <p class="mb-4">
      The current meeting will be automatically selected, but you can select
      additional meetings to compare the numbers. Select or type into the drop
      down and click the "Add" button and then click "Download Report" when
      finished.
    </p>

    <div class="mb-8 flex flex-col lg:flex-row w-full">
      <multiselect
        v-model="selectedValue"
        label="name"
        track-by="id"
        class="max-w-sm mb-4"
        :options="meetingsList"
      >
      </multiselect>
      <button @click="add" class="self-end lg:self-auto lg:ml-4 button">
        <span class="icon"><i class="fas fa-plus"></i></span>
        <span>Add</span>
      </button>
    </div>

    <h4 v-if="selectedMeetings.length" class="title is-4">
      Comparison Metings
    </h4>
    <div v-for="(meeting, idx) in selectedMeetings" :key="idx" class="mt-2">
      <span class="subtitle is-6">{{ meeting.name }}</span>
      <span><a @click.prevent="remove(meeting.id)">(remove)</a></span>
    </div>

    <form ref="form" :action="functionUrl" method="POST" class="mt-16">
      <input type="hidden" name="token" :value="token" />
      <input
        type="hidden"
        name="meetingIds"
        :value="selectedMeetingIdFormData"
      />
      <input
        type="submit"
        value="Download Report"
        :disabled="!token"
        class="button is-success is-medium w-full lg:w-auto"
      />
    </form>
  </div>
</template>

<script>
import { db } from '@/services/firebase';
import Multiselect from 'vue-multiselect';

export default {
  data() {
    return {
      meetings: [],
      selectedValue: null,
      selectedMeetings: [],
      token: null,
      functionUrl: `${process.env.FIREBASE_FUNCTIONS_DOMAIN}/getSummaryReport`
    };
  },
  computed: {
    meetingsList() {
      return this.meetings
        .filter(
          meeting =>
            !this.selectedMeetings.some(
              selectedMeeting => selectedMeeting.id === meeting.id
            ) && meeting.id !== this.$route.params.id
        )
        .map(meeting => {
          return {
            name: meeting.name,
            id: meeting.id
          };
        });
    },
    selectedMeetingIdFormData() {
      const selectedMeetingIds = [this.$route.params.id];
      for (const meeting of this.selectedMeetings) {
        selectedMeetingIds.push(meeting.id);
      }
      return selectedMeetingIds.join(',');
    }
  },
  methods: {
    add() {
      if (this.selectedValue) {
        this.selectedMeetings.push(this.selectedValue);
      }
      this.selectedValue = null;
    },
    remove(meetingId) {
      this.selectedMeetings = this.selectedMeetings.filter(
        meeting => meeting.id !== meetingId
      );
    }
  },
  firestore() {
    return {
      meetings: db.collection('meetings')
    };
  },
  async created() {
    this.token = await this.$store.getters.token;
  },
  components: {
    Multiselect
  }
};
</script>



// WEBPACK FOOTER //
// src/components/meeting/SummaryReportBuilder.vue